import React from 'react';
import { useFormat } from '../../i18n/format.js';

// Pastille « relié à GarageManager » d'un fournisseur (2026-09-19).
// Ne dit que ce que FMM sait : la date du dernier « hello » reçu du garage (partner_last_seen_at).
// Il n'y a pas encore de battement de cœur : vert = contact récent, gris = silencieux depuis
// SILENT_AFTER_DAYS. Jamais de rouge — un garage qui ne parle pas n'est pas en panne pour autant.
// Aucun contact enregistré : rien n'est affiché.
const SILENT_AFTER_DAYS = 7;

export default function PartnerLinkDot({ supplier, showLabel = true }) {
  const { t, fmt } = useFormat();
  const seenAt = supplier?.partner_last_seen_at;
  if (!seenAt) return null;

  const ageDays = (Date.now() - new Date(seenAt).getTime()) / 86_400_000;
  const live = ageDays <= SILENT_AFTER_DAYS;
  const title = t('suppliers.partnerLink.tooltip', { date: fmt.dateTime(seenAt) });

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${
        live ? 'bg-green-50 text-green-700 border-green-200' : 'bg-gray-50 text-gray-500 border-gray-200'
      }`}
      title={title}
    >
      <span className="relative flex w-2 h-2">
        {live && <span className="absolute inline-flex w-full h-full rounded-full bg-green-400 opacity-75 animate-ping" />}
        <span className={`relative inline-flex w-2 h-2 rounded-full ${live ? 'bg-green-500' : 'bg-gray-400'}`} />
      </span>
      {showLabel && (live ? t('suppliers.partnerLink.connected') : t('suppliers.partnerLink.silent'))}
    </span>
  );
}
